import Container from "../../../components/element/container";
import { useEffect, useState } from "react";

//lib
import { MDBModalBody } from "mdb-react-ui-kit";
import Accordion from "react-bootstrap/Accordion";

//redux
import { useDispatch, useSelector } from "react-redux";
import { setFilterData } from "../../../redux/reducer/product.reducer";
import { closeFilterModal } from "../../../redux/reducer/modal.reducer";

//assets
import {
  Convertible,
  Coupe,
  Hatchback,
  MPV,
  Sedan,
  SUV,
  Truck,
  Wagon,
} from "../../../assets/images";

//component
import FullModal from "../../../components/modal/full.modal";
import Row from "../../../components/element/row";
import Button from "../../../components/element/button";
import Col from "../../../components/element/col";
import Icon from "../../../components/element/icon";
import Image from "../../../components/element/image";
import RangeSlider from "react-range-slider-input";
import {
  getBrandList,
  getModelList,
} from "../../../redux/reducer/common.reducer";
import formatNumber from "../../../helpers/format.number";
import { useTranslation } from "react-i18next";

export default function FilterModal({ type }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isOpenFilterModal } = useSelector((state) => state.modal);
  const { filterData, productList } = useSelector((state) => state.product);
  const { brandList, modelOption } = useSelector((state) => state.common);

  const [activeBrand, setActiveBrand] = useState([]);
  const [draftFilterData, setDraftFilterData] = useState(() => filterData);

  const category = draftFilterData.category || "all";
  const categoryData = draftFilterData[category] || {};

  const brandOption =
    brandList?.length > 0
      ? brandList.map((brand) => ({
          id: brand.id,
          label: brand.name,
        }))
      : [];

  // const brandList = [
  //   { id: 1, label: "Tesla" },
  //   { id: 2, label: "Toyota" },
  //   { id: 3, label: "Honda" },
  //   { id: 4, label: "BMW" },
  //   { id: 5, label: "Mercedes Benz" },
  // ];

  // const modelList = {
  //   1: [
  //     { id: 6, brand_id: 1, label: "Model-X" },
  //     { id: 7, brand_id: 1, label: "Model-Y" },
  //   ],
  //   2: [
  //     { id: 8, brand_id: 2, label: "Vios" },
  //     { id: 9, brand_id: 2, label: "Camry" },
  //   ],
  //   3: [
  //     { id: 10, brand_id: 3, label: "City" },
  //     { id: 11, brand_id: 3, label: "Civic" },
  //   ],
  //   4: [
  //     { id: 12, brand_id: 4, label: "1 Series" },
  //     { id: 13, brand_id: 4, label: "2 Series" },
  //   ],
  //   5: [
  //     { id: 14, brand_id: 5, label: "S250" },
  //     { id: 15, brand_id: 5, label: "C250" },
  //   ],
  // };

  const bodyTypeList = [
    { label: "Convertible", img: Convertible },
    { label: "Coupe", img: Coupe },
    { label: "Hatchback", img: Hatchback },
    { label: "MPV", img: MPV },
    { label: "Sedan", img: Sedan },
    { label: "SUV", img: SUV },
    { label: "Truck", img: Truck },
    { label: "Wagon", img: Wagon },
  ];

  const locationOption =
    productList?.show_rooms?.length > 0
      ? Array.from(new Set(productList.show_rooms.map((s) => s.state))).map(
          (state) => ({
            label: state,
          }),
        )
      : [];

  const showroomOption =
    productList?.show_rooms?.length > 0
      ? productList.show_rooms.reduce((acc, item) => {
          const { state, name } = item;

          if (!acc[state]) {
            acc[state] = [];
          }

          acc[state].push(name);

          return acc;
        }, {})
      : [];

  const currentYear = new Date().getFullYear();

  const [filterList, setFilterList] = useState({
    "Brand Model": {
      list: brandOption,
      name: "brand",
      key: "id",
      subList: modelOption,
      subName: "car_model",
      subKey: "id",
      newState: {
        brand: [],
        model: [],
      },
    },
    Location: {
      list: locationOption,
      name: "location",
      key: "label",
      subList: showroomOption,
      subName: "show_room",
      subKey: "",
      newState: {
        location: [],
        showroom: [],
      },
    },
    "Body Type": {
      list: bodyTypeList,
      name: "body_type",
      key: "label",
      newState: {
        body_type: [],
      },
    },
    Year: {
      name: "year",
      sliderMin: 2000,
      sliderMax: currentYear,
      min: 2016,
      max: currentYear,
      newState: {
        year: [2016, currentYear],
      },
    },
    Price: {
      name: "price",
      sliderMin: 50000,
      sliderMax: 5000000,
      min: 100000,
      max: 1000000,
      newState: {
        price: [100000, 1000000],
      },
    },
  });

  const handleOpenAccordion = (index) => {
    setActiveBrand((prev) => {
      if (prev.includes(index)) {
        return prev.filter((prevKey) => prevKey !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  const handleFilter = (
    type,
    value,
    mainList,
    mainId,
    mainLocation,
    subType,
    subList,
  ) => {
    let newStateData = {};
    let newTypeData = [];
    const typeData = categoryData[type] || [];

    if (type === "car_model" || type === "show_room") {
      if (mainId) {
        const remainingMainData =
          mainList
            ?.filter(
              (main) => (type === "car_model" ? main.id : main) !== value,
            )
            .map((m) => (type === "car_model" ? m.id : m)) || [];

        newStateData = {
          ...draftFilterData,
          [category]: {
            ...categoryData,
            [type]: Array.from(
              new Set([
                ...typeData.filter((v) => v !== value),
                ...remainingMainData,
              ]),
            ),
            [type === "car_model" ? "brand" : "location"]: categoryData?.[
              type === "car_model" ? "brand" : "location"
            ].filter((v) => v !== mainId),
          },
        };
      } else {
        let totalMain = [...typeData, value];

        const includeAllMain =
          mainList?.length > 0
            ? mainList.every((main) =>
                totalMain.includes(type === "car_model" ? main.id : main),
              )
            : false;

        if (includeAllMain) {
          totalMain = totalMain.filter((data) => {
            return type === "car_model"
              ? !mainList.some((m) => m.id === data)
              : !mainList.some((m) => m === data);
          });

          newStateData = {
            ...draftFilterData,
            [category]: {
              ...categoryData,
              [type]: totalMain,
              [type === "car_model" ? "brand" : "location"]: Array.from(
                new Set([
                  ...(categoryData?.[
                    type === "car_model" ? "brand" : "location"
                  ] || []),
                  type === "car_model" ? mainList[0]?.brand_id : mainLocation,
                ]),
              ),
            },
          };
        } else {
          newTypeData = typeData.includes(value)
            ? typeData.filter((v) => v !== value)
            : [...typeData, value];

          newStateData = {
            ...draftFilterData,
            [category]: {
              ...categoryData,
              [type]: newTypeData,
            },
          };
        }
      }
    } else {
      newTypeData = typeData.includes(value)
        ? typeData.filter((v) => v !== value)
        : [...typeData, value];

      let subTypeData = categoryData[subType] || [];

      var subListData = Array.isArray(subList)
        ? type === "brand"
          ? subList.map((m) => m.id)
          : subList.map((m) => m)
        : [];

      if (!typeData.includes(value)) {
        subTypeData = subTypeData.filter((data) => !subListData.includes(data));
      }

      newStateData = {
        ...draftFilterData,
        [category]: {
          ...categoryData,
          [type]: newTypeData,
          ...(type === "brand"
            ? { car_model: subTypeData }
            : { show_room: subTypeData }),
        },
      };
    }

    setDraftFilterData(newStateData);
  };

  const currentFilter = filterList[type];

  const handleCloseFilter = () => {
    setActiveBrand([]);
    dispatch(closeFilterModal());
  };

  const handleClear = () => {
    setDraftFilterData({
      ...draftFilterData,
      [category]: {
        ...categoryData,
        ...currentFilter.newState,
      },
    });
  };

  const handleApply = () => {
    const appliedCategoryData = {
      ...categoryData,
      start: 0,
      refresh_key: Date.now(),
    };
    const appliedFilterData = {
      ...draftFilterData,
      [category]: appliedCategoryData,
    };

    dispatch(setFilterData(appliedFilterData));
    handleCloseFilter();
  };

  const [sliderReady, setSliderReady] = useState(false);

  // useEffect(() => {
  //   dispatch(
  //     setFilterData({
  //       ...filterData,
  //       [category]: {
  //         ...categoryData,
  //         // ...applyFilterData,
  //       },
  //     })
  //   );
  // }, []);

  useEffect(() => {
    if (!isOpenFilterModal) {
      setSliderReady(false);
      return;
    }

    const t = setTimeout(() => {
      setSliderReady(true);
    }, 350);

    return () => clearTimeout(t);
  }, [isOpenFilterModal]);

  useEffect(() => {
    if (type === "Brand Model") {
      dispatch(getBrandList());
      dispatch(getModelList());
    }
  }, [type]);

  // useEffect(() => {
  //   if (type === "Price" || type === "Year") {
  //     const categoryType = type.toLowerCase();
  //     const defaultValue = type === "Year" ? "" : 0;

  //     if (categoryData[categoryType]?.length > 0) {
  //       if (
  //         categoryData[categoryType]?.[0] == defaultValue &&
  //         categoryData[categoryType]?.[1] == defaultValue
  //       ) {
  //         setFilterList({
  //           ...filterList,
  //           [type]: {
  //             ...filterList[type],
  //             min: "",
  //             max: "",
  //           },
  //         });
  //       }

  //       if (
  //         categoryData[categoryType]?.[0] == defaultValue ||
  //         (categoryData[categoryType]?.[0] &&
  //           Number(categoryData[categoryType]?.[0]) != filterList[type].min)
  //       ) {
  //         setFilterList({
  //           ...filterList,
  //           [type]: {
  //             ...filterList[type],
  //             min: "",
  //           },
  //         });
  //       }

  //       if (
  //         categoryData[categoryType]?.[1] == defaultValue ||
  //         (categoryData[categoryType]?.[1] &&
  //           Number(categoryData[categoryType]?.[1]) != filterList[type].max)
  //       ) {
  //         setFilterList({
  //           ...filterList,
  //           [type]: {
  //             ...filterList[type],
  //             max: "",
  //           },
  //         });
  //       }
  //     }
  //   }
  // }, [categoryData, type]);

  useEffect(() => {
    if (type !== "Price" && type !== "Year") return;

    const categoryType = type.toLowerCase();
    const values = categoryData?.[categoryType];

    if (!values || values.length < 2) return;

    const [minSlider, maxSlider] = values;
    const defaultValue = type === "Year" ? "" : 0;

    setFilterList((prev) => {
      const current = prev[type];

      if (!current) return prev;

      let newMin = current.min;
      let newMax = current.max;

      if (
        minSlider === defaultValue ||
        Number(minSlider) !== Number(current.min)
      ) {
        newMin = "";
      }

      if (
        maxSlider === defaultValue ||
        Number(maxSlider) !== Number(current.max)
      ) {
        newMax = "";
      }

      // prevent unnecessary re-render
      if (newMin === current.min && newMax === current.max) {
        return prev;
      }

      return {
        ...prev,
        [type]: {
          ...current,
          min: newMin,
          max: newMax,
        },
      };
    });
  }, [categoryData, type]);

  return (
    <FullModal
      staticBackdrop={true}
      show={isOpenFilterModal}
      close={handleCloseFilter}
      screenSize="lg"
      className="filter-modal"
      content={
        <MDBModalBody>
          <Col
            className={`flex-col w-100 gap-${
              type === "Year" || type === "Price" ? 3 : 0
            }`}
          >
            <h3 className="_label filter-title">
              {t("Filter")} {t(type)}
            </h3>
            {type === "Year" || type === "Price" ? (
              <Container tag="div" className="--year">
                {sliderReady && (
                  <RangeSlider
                    min={currentFilter?.sliderMin}
                    max={currentFilter?.sliderMax}
                    step={type === "Year" ? 1 : 50000}
                    value={
                      categoryData?.[currentFilter?.name] || [
                        currentFilter?.min,
                        currentFilter?.max,
                      ]
                    }
                    onInput={(value) => {
                      setDraftFilterData({
                        ...draftFilterData,
                        [category]: {
                          ...categoryData,
                          [currentFilter?.name]: value,
                        },
                      });
                    }}
                  />
                )}
                <article className="year-input mt-4">
                  <section className="w-100">
                    <p className="_label year-title">Min. {type}</p>
                    <input
                      maxLength={type === "Year" ? "4" : ""}
                      // type="number"
                      value={
                        type === "Year"
                          ? categoryData[currentFilter?.name]?.[0] != "" ||
                            currentFilter?.min != ""
                            ? categoryData[currentFilter?.name]?.[0] ||
                              currentFilter?.min
                            : ""
                          : Number(
                                categoryData[currentFilter?.name]?.[0] ||
                                  currentFilter?.min,
                              ) > 0
                            ? formatNumber(
                                categoryData[currentFilter?.name]?.[0] ||
                                  currentFilter?.min,
                              )
                            : 0
                      }
                      onChange={(e) => {
                        const numericValue =
                          e.target.value
                            ?.replace(/\D/g, "")
                            .replace(/^0+(?=\d)/, "") ||
                          (type === "Year" ? "" : 0);

                        setDraftFilterData({
                          ...draftFilterData,
                          [category]: {
                            ...categoryData,
                            [currentFilter?.name]: [
                              numericValue,
                              categoryData?.[currentFilter?.name]?.[1] ||
                                currentFilter?.max ||
                                (type === "Year" ? "" : 0),
                            ],
                          },
                        });
                      }}
                    />
                  </section>
                  <p className="mb-3">-</p>
                  <section className="w-100">
                    <p className="_label year-title">Max. {type}</p>
                    <input
                      maxLength={type === "Year" ? "4" : ""}
                      // type="number"
                      value={
                        type === "Year"
                          ? categoryData[currentFilter?.name]?.[1] != "" ||
                            currentFilter?.max != ""
                            ? categoryData[currentFilter?.name]?.[1] ||
                              currentFilter?.max
                            : ""
                          : Number(
                                categoryData[currentFilter?.name]?.[1] ||
                                  currentFilter?.max,
                              ) > 0
                            ? formatNumber(
                                categoryData[currentFilter?.name]?.[1] ||
                                  currentFilter?.max,
                              )
                            : 0
                      }
                      onChange={(e) => {
                        const numericValue =
                          e.target.value
                            ?.replace(/\D/g, "")
                            .replace(/^0+(?=\d)/, "") ||
                          (type === "Year" ? "" : 0);

                        setDraftFilterData({
                          ...draftFilterData,
                          [category]: {
                            ...categoryData,
                            [currentFilter?.name]: [
                              categoryData?.[currentFilter?.name]?.[0] ||
                                currentFilter?.min ||
                                (type === "Year" ? "" : 0),
                              numericValue,
                            ],
                          },
                        });
                      }}
                    />
                  </section>
                </article>
              </Container>
            ) : (
              <Accordion activeKey={activeBrand} alwaysOpen flush>
                {currentFilter?.list.length > 0 &&
                  [...currentFilter?.list]
                    .sort((a, b) => a.label.localeCompare(b.label))
                    .map((main, mainIndex) => (
                      <Accordion.Item eventKey={mainIndex}>
                        <Accordion.Header
                          onClick={() => handleOpenAccordion(mainIndex)}
                        >
                          <Row className="flex justify-between w-100">
                            <section
                              className="flex items-center gap-4"
                              key={mainIndex}
                            >
                              <article
                                className="checkbox-wrapper"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleFilter(
                                    currentFilter?.name,
                                    main[currentFilter?.key],
                                    null,
                                    null,
                                    null,
                                    type !== "Body Type"
                                      ? currentFilter?.subName
                                      : null,
                                    type !== "Body Type"
                                      ? type === "Brand Model"
                                        ? currentFilter?.subList[main.id]
                                        : currentFilter?.subList[main.label]
                                      : null,
                                  );
                                }}
                              >
                                <label>
                                  <input
                                    className="pointer"
                                    type="checkbox"
                                    checked={
                                      categoryData?.[currentFilter.name]
                                        ?.length > 0 &&
                                      categoryData?.[
                                        currentFilter.name
                                      ].includes(main[currentFilter.key])
                                    }
                                  />
                                  <span className="checkbox"></span>
                                </label>
                              </article>
                              <Row className="items-center gap-4">
                                {main.img && (
                                  <Image
                                    src={main.img}
                                    alt=""
                                    className="_img"
                                  />
                                )}
                                <p className="_label brand-title">
                                  {t(main.label)}
                                </p>
                              </Row>
                            </section>
                            {type !== "Body Type" && (
                              <Icon
                                icon="icon-park-outline:down"
                                className="_svg"
                              />
                            )}
                          </Row>
                        </Accordion.Header>
                        {(type === "Brand Model" || type === "Location") && (
                          <Accordion.Body>
                            <Row className="_row model-list">
                              {[
                                ...(Array.isArray(
                                  currentFilter?.subList?.[
                                    main?.[currentFilter?.key]
                                  ],
                                )
                                  ? currentFilter.subList[
                                      main[currentFilter.key]
                                    ]
                                  : []),
                              ]
                                .sort((a, b) => {
                                  const isANumeric = /^\d/.test(
                                    type === "Brand Model" ? a.label : a,
                                  );
                                  const isBNumeric = /^\d/.test(
                                    type === "Brand Model" ? b.label : b,
                                  );

                                  if (isANumeric && !isBNumeric) return 1;
                                  if (!isANumeric && isBNumeric) return -1;
                                  return (
                                    type === "Brand Model" ? a.label : a
                                  ).localeCompare(
                                    type === "Brand Model" ? b.label : b,
                                    undefined,
                                    {
                                      numeric: true,
                                    },
                                  );
                                })
                                .map((subItem, subItemIndex) => (
                                  <article
                                    className={`pointer _col model-item
                                    ${
                                      (categoryData?.[currentFilter.name]
                                        ?.length > 0 &&
                                        categoryData?.[
                                          currentFilter.name
                                        ].includes(
                                          type === "Brand Model"
                                            ? main.id
                                            : main.label,
                                        )) ||
                                      (categoryData?.[currentFilter.subName]
                                        ?.length > 0 &&
                                        categoryData?.[
                                          currentFilter.subName
                                        ].includes(
                                          type === "Brand Model"
                                            ? subItem.id
                                            : subItem,
                                        ))
                                        ? "active"
                                        : ""
                                    }`}
                                    key={subItemIndex}
                                    onClick={() =>
                                      handleFilter(
                                        currentFilter?.subName,
                                        type === "Brand Model"
                                          ? subItem.id
                                          : subItem,
                                        currentFilter?.subList[
                                          type === "Brand Model"
                                            ? main.id
                                            : main.label
                                        ],
                                        categoryData?.[currentFilter?.name]
                                          ?.length > 0 &&
                                          categoryData?.[
                                            currentFilter?.name
                                          ].includes(main[currentFilter?.key])
                                          ? main[currentFilter?.key]
                                          : null,
                                        main.label,
                                      )
                                    }
                                  >
                                    <p className="_label model-title">
                                      {type === "Brand Model"
                                        ? subItem.label
                                        : subItem}
                                    </p>
                                  </article>
                                ))}
                            </Row>
                          </Accordion.Body>
                        )}
                      </Accordion.Item>
                    ))}
              </Accordion>
            )}
          </Col>
          <Col className="_col filter-footer">
            <hr className="_hr" />
            <Row className="flex justify-between">
              <Button className="_button clear" onClick={() => handleClear()}>
                {type === "Year" || type === "Price" ? "Reset" : "Clear"}
              </Button>
              <Button className="_button apply" onClick={() => handleApply()}>
                {t("Apply")}
              </Button>
            </Row>
          </Col>
        </MDBModalBody>
      }
    />
  );
}
